import { render, staticRenderFns } from "./create-user-form.vue?vue&type=template&id=73a09a72&scoped=true&"
import script from "./create-user-form.vue?vue&type=script&lang=js&"
export * from "./create-user-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a09a72",
  null
  
)

export default component.exports